import { SmartfireComponent } from "@smartfire/gutenberg-react";
import "./style.scss";
import CapsaTitle from "../CapsaTitle/block.js";
import CapsaTitleMiniature from "../capsa-title-miniature/capsaTitleMiniature.js";
import * as React from "react";

export default class BlocklistMiniatureBlock extends SmartfireComponent {
  constructor(props) {
    super(props);

    if (this.props.type === "related") this.type = "no-description";
    else if (!this.props.image) this.type = "no-image";
    else this.type = "full";

    this.state = { width: props.width };
  }
  componentWillMount() {
    this.setState({ width: window.innerWidth });
  }
  render() {
    return (
      <a href={this.props.url}>
        <div className={"miniature-block " + this.type}>
          <div
            className="image"
            style={
              this.props.image
                ? { backgroundImage: "url(" + this.props.image + ")" }
                : null
            }
          />
          {this.state.width <= 1776 ? (
            <CapsaTitleMiniature title={this.props.title} />
          ) : (
            <CapsaTitle title={this.props.title} />
          )}
          <p
            className="description"
            dangerouslySetInnerHTML={{ __html: this.props.description }}
          />
          {this.props.showSlideButton && <div className="slide-button" />}
        </div>
      </a>
    );
  }
}
